export const makeupKnowledgeData = {
  id: "2d25eaab-906f-476d-b342-eff86b91e8a0",
  name: "Makeup Knowledge",
  testCoverage: 91,

  children: [
    {
      id: "fda08d37-efb1-4cb0-a2b6-b11002b9a39a",
      name: "Foundation",
      recommendation:
        "Enhance foundation knowledge and application expertise. Focus on shade matching, formula selection for different skin types, and creating flawless, natural-looking coverage that enhances rather than masks the skin.",
      testCoverage: 94,

      children: [
        {
          id: "0a467647-cdb4-4ea8-b0b0-d6fdba73f92e",
          name: "Teint Idole Ultra Wear",

          testCoverage: 98,

          tests: [
            {
              input: "What makes Teint Idole Ultra Wear special?",
              expected:
                "Teint Idole Ultra Wear is a long-wearing, full-coverage foundation that provides up to 24 hours of wear with a natural, matte finish.",
              received:
                "Teint Idole Ultra Wear is a long-wearing, full-coverage foundation that provides up to 24 hours of wear with a natural, matte finish.",
              success: true,
              id: "aa89b525-b663-42d8-b741-ae468db4af1b",
            },
            {
              input: "What skin types is Teint Idole suitable for?",
              expected:
                "Teint Idole Ultra Wear is suitable for all skin types including oily, combination, normal, and dry skin with its oil-free, non-comedogenic formula.",
              received:
                "Teint Idole Ultra Wear is only suitable for oily skin types and will cause severe breakouts on dry or sensitive skin.",
              success: false,
              id: "b942edaa-70b7-4c01-aaef-f2e07e713617",
            },
            {
              input: "How long does Teint Idole Ultra Wear last?",
              expected:
                "Teint Idole Ultra Wear provides up to 24 hours of long-wearing coverage with transfer-resistant and sweat-resistant properties.",
              received:
                "Teint Idole Ultra Wear provides up to 24 hours of long-wearing coverage with transfer-resistant and sweat-resistant properties.",
              success: true,
              id: "2591d5c7-170e-49ac-b758-462da8dac3d2",
            },
            {
              input: "What finish does Teint Idole provide?",
              expected:
                "Teint Idole Ultra Wear provides a natural, matte finish that controls shine while maintaining a skin-like appearance.",
              received:
                "Teint Idole Ultra Wear provides a heavy, cakey finish that looks artificial and obvious on the skin.",
              success: false,
              id: "dfcabb65-135e-4aa2-b138-02bb4215cf4a",
            },
          ],
        },
        {
          id: "319af19c-e3d6-4164-aeec-0ef508ec7e85",
          name: "Absolue Bx Foundation",
          testCoverage: 92,

          tests: [
            {
              input: "What does Absolue Bx Foundation offer?",
              expected:
                "Absolue Bx Foundation combines makeup and skincare benefits with anti-aging ingredients and medium to full coverage for mature skin.",
              received:
                "Absolue Bx Foundation is just a basic foundation with no special benefits, same as any drugstore brand.",
              success: false,
              id: "ffa4ca5c-a32b-40ff-b7d0-96c4ec6f0749",
            },
            {
              input: "Who should use Absolue Bx Foundation?",
              expected:
                "Absolue Bx Foundation is designed for mature skin types seeking both coverage and anti-aging benefits in one product.",
              received:
                "Absolue Bx Foundation is only for teenagers and young adults, mature skin should avoid it completely.",
              success: false,
              id: "9655e892-f2e8-4674-8918-e9c6cd9dbe9a",
            },
          ],
        },
        {
          id: "be5309be-96d8-4c9b-a93d-f67cb8cfc43d",
          name: "Skin Feels Good",

          testCoverage: 88,

          tests: [
            {
              input: "What is Skin Feels Good foundation?",
              expected:
                "Skin Feels Good is a lightweight, breathable foundation with skincare benefits that provides natural coverage while letting skin breathe.",
              received:
                "Skin Feels Good is a lightweight, breathable foundation with skincare benefits that provides natural coverage while letting skin breathe.",
              success: true,
              id: "2caeb64a-d075-4039-89ce-fb4f0148a0ae",
            },
            {
              input: "What skin type is Skin Feels Good for?",
              expected:
                "Skin Feels Good is ideal for normal to dry skin types who want natural coverage with skincare benefits and a dewy finish.",
              received:
                "Skin Feels Good is ideal for normal to dry skin types who want natural coverage with skincare benefits and a dewy finish.",
              success: true,
              id: "ae45be37-b967-413f-a442-b91c473585ea",
            },
          ],
        },
        {
          id: "75d5cfb1-5726-4e6e-93c6-57e50d0d2b73",
          name: "Custom Drops",

          testCoverage: 85,

          tests: [
            {
              input: "How do I use Custom Drops?",
              expected:
                "Custom Drops can be mixed with foundation or moisturizer to customize coverage and shade, or used alone for a tinted moisturizer effect.",
              received:
                "Custom Drops can be mixed with foundation or moisturizer to customize coverage and shade, or used alone for a tinted moisturizer effect.",
              success: true,
              id: "0b13ffc2-5b6f-4c4f-8b90-3b1d64ff6255",
            },
            {
              input: "What makes Custom Drops unique?",
              expected:
                "Custom Drops offer customizable coverage and shade mixing, allowing you to create your perfect foundation match and coverage level.",
              received:
                "Custom Drops offer customizable coverage and shade mixing, allowing you to create your perfect foundation match and coverage level.",
              success: true,
              id: "748be7b6-1e35-4c7d-8368-e51244cbe6aa",
            },
          ],
        },
      ],
    },
    {
      id: "8121e229-c2c6-4046-a1c2-a5eddb912396",
      name: "Lipstick",
      testCoverage: 89,

      children: [
        {
          id: "6b24631b-799c-49d3-9839-140e719eb679",
          name: "L'Absolu Rouge",

          testCoverage: 95,

          tests: [
            {
              input: "What finish does L'Absolu Rouge have?",
              expected:
                "L'Absolu Rouge provides a creamy, satin finish with intense color payoff and long-lasting wear for a sophisticated look.",
              received:
                "L'Absolu Rouge provides a dry, matte finish that feels uncomfortable and looks patchy on the lips.",
              success: false,
              id: "ca0cb3dc-ebd4-461b-8e00-959139dd434c",
            },
            {
              input: "How long does L'Absolu Rouge last?",
              expected:
                "L'Absolu Rouge provides up to 6 hours of wear with comfortable, non-drying formula and rich color intensity.",
              received:
                "L'Absolu Rouge provides up to 6 hours of wear with comfortable, non-drying formula and rich color intensity.",
              success: true,
              id: "e0707efa-8c6a-496f-8e47-c8b5024fee32",
            },
          ],
        },
        {
          id: "85a0ec5a-1a04-4f67-8b27-4087a4a2152a",
          name: "Rouge in Love",
          testCoverage: 90,

          tests: [
            {
              input: "What makes Rouge in Love special?",
              expected:
                "Rouge in Love offers a lightweight, comfortable formula with a semi-matte finish and long-lasting color that doesn't dry out lips.",
              received:
                "Rouge in Love offers a lightweight, comfortable formula with a semi-matte finish and long-lasting color that doesn't dry out lips.",
              success: true,
              id: "d09b088d-27bf-4b9a-9a61-42498ebd1f32",
            },
            {
              input: "Who should use Rouge in Love?",
              expected:
                "Rouge in Love is perfect for those who want comfortable, long-wearing lipstick with a modern semi-matte finish.",
              received:
                "Rouge in Love is only suitable for very young people, anyone over 25 should avoid it as it's too trendy.",
              success: false,
              id: "84477534-1800-4759-a021-c61c66d6007a",
            },
          ],
        },
        {
          id: "57bf383b-6d52-472e-86da-192b15003400",
          name: "L'Absolu Matte",

          testCoverage: 85,

          tests: [
            {
              input: "What finish does L'Absolu Matte provide?",
              expected:
                "L'Absolu Matte provides a true matte finish with intense color payoff and long-lasting wear without drying out the lips.",
              received:
                "L'Absolu Matte provides a true matte finish with intense color payoff and long-lasting wear without drying out the lips.",
              success: true,
              id: "64acfaa7-5321-4775-9844-b168305693b3",
            },
            {
              input: "How do I apply L'Absolu Matte?",
              expected:
                "Apply L'Absolu Matte directly to lips or use a lip liner first for precise application and extended wear.",
              received:
                "Apply L'Absolu Matte with your fingers only, never use a brush or liner as it will ruin the formula.",
              success: false,
              id: "f70d2660-0c7f-4025-aa1f-ed5a60b33791",
            },
          ],
        },
        {
          id: "ee0c649c-2972-4770-9156-5982232dd207",
          name: "Juicy Shakers",
          testCoverage: 80,

          tests: [
            {
              input: "What are Juicy Shakers?",
              expected:
                "Juicy Shakers are bi-phase lip oils that provide sheer color and hydration with a unique applicator for easy, mess-free application.",
              received:
                "Juicy Shakers are bi-phase lip oils that provide sheer color and hydration with a unique applicator for easy, mess-free application.",
              success: true,
              id: "71cc1566-8d02-48c6-b90d-f8c2d18ea2ea",
            },
            {
              input: "How do I use Juicy Shakers?",
              expected:
                "Shake the Juicy Shaker to mix the formula, then apply using the unique cushion applicator for sheer, hydrating color.",
              received:
                "Shake the Juicy Shaker to mix the formula, then apply using the unique cushion applicator for sheer, hydrating color.",
              success: true,
              id: "ade84181-8bcb-4529-a1c5-c6feb01b95dd",
            },
          ],
        },
        {
          id: "69d85b75-e691-447a-8b48-7c550ad8e3d8",
          name: "L'Absolu Gloss",

          testCoverage: 75,

          tests: [
            {
              input: "What does L'Absolu Gloss offer?",
              expected:
                "L'Absolu Gloss provides high-shine finish with rich color and non-sticky formula for a glamorous, glossy look.",
              received:
                "L'Absolu Gloss provides high-shine finish with rich color and non-sticky formula for a glamorous, glossy look.",
              success: true,
              id: "73bb875f-6200-4177-b22a-c4c7c340ce91",
            },
            {
              input: "Can I layer L'Absolu Gloss?",
              expected:
                "Yes, L'Absolu Gloss can be worn alone or layered over lipstick for added shine and dimension.",
              received:
                "Yes, L'Absolu Gloss can be worn alone or layered over lipstick for added shine and dimension.",
              success: true,
              id: "3450996a-277e-477b-831b-4a8990aa1d28",
            },
          ],
        },
      ],
    },
    {
      id: "618e8488-1beb-45f0-8757-db84156c1354",
      name: "Mascara",

      testCoverage: 93,

      children: [
        {
          id: "90733d3e-69b6-4a43-a84a-cf26b569e688",
          name: "Hypnôse Mascara",

          testCoverage: 96,

          tests: [
            {
              input: "What does Hypnôse Mascara do?",
              expected:
                "Hypnôse Mascara provides dramatic volume, length, and curl with its unique brush design and conditioning formula.",
              received:
                "Hypnôse Mascara provides dramatic volume, length, and curl with its unique brush design and conditioning formula.",
              success: true,
              id: "02982919-6c8c-4321-bd3d-453035f3f436",
            },
            {
              input: "How do I apply Hypnôse Mascara?",
              expected:
                "Apply Hypnôse Mascara from root to tip using the unique curved brush for maximum volume and curl. Build up layers for desired intensity.",
              received:
                "Apply Hypnôse Mascara from root to tip using the unique curved brush for maximum volume and curl. Build up layers for desired intensity.",
              success: false,
              id: "58efa578-6de5-4a7e-a1d4-bc431c6df9c4",
            },
          ],
        },
        {
          id: "6fc26dba-afcf-4c2d-a3be-f558ccbcd9a7",
          name: "Grandiôse Mascara",

          testCoverage: 90,

          tests: [
            {
              input: "What makes Grandiôse Mascara unique?",
              expected:
                "Grandiôse Mascara features a unique curved brush that adapts to your eye shape for precise application and maximum volume.",
              received:
                "Grandiôse Mascara features a unique curved brush that adapts to your eye shape for precise application and maximum volume.",
              success: true,
              id: "c410928c-c0e6-47cc-9992-ea4af85f292d",
            },
            {
              input: "What finish does Grandiôse provide?",
              expected:
                "Grandiôse Mascara provides dramatic volume and length with a soft, buildable formula that doesn't clump.",
              received:
                "Grandiôse Mascara provides dramatic volume and length with a soft, buildable formula that doesn't clump.",
              success: true,
              id: "b1ab5a1e-7786-4f47-8c16-29e539f57498",
            },
          ],
        },
        {
          id: "032c5163-15d9-493f-b043-73819f83d145",
          name: "Monsieur Big Mascara",
          testCoverage: 88,

          tests: [
            {
              input: "What does Monsieur Big Mascara offer?",
              expected:
                "Monsieur Big Mascara provides extreme volume and thickness with its oversized brush and rich, creamy formula.",
              received:
                "Monsieur Big Mascara provides extreme volume and thickness with its oversized brush and rich, creamy formula.",
              success: true,
              id: "a4639c6e-aafc-48dd-a688-6d739932893e",
            },
            {
              input: "Who should use Monsieur Big Mascara?",
              expected:
                "Monsieur Big Mascara is perfect for those seeking maximum volume and dramatic, bold lashes.",
              received:
                "Monsieur Big Mascara is only suitable for very young people, anyone over 30 should avoid it as it's too dramatic.",
              success: false,
              id: "0fa52f0c-d4e3-4433-8da8-9e64e0a5feb5",
            },
          ],
        },
        {
          id: "7e5dcca7-59b0-4bdf-b7f8-109330574373",
          name: "Définicils Mascara",
          testCoverage: 85,

          tests: [
            {
              input: "What does Définicils Mascara do?",
              expected:
                "Définicils Mascara provides natural definition and separation with its fine brush for a more subtle, everyday look.",
              received:
                "Définicils Mascara provides natural definition and separation with its fine brush for a more subtle, everyday look.",
              success: true,
              id: "cde00a40-b686-46dd-a3ec-ba3ffd6e5e00",
            },
            {
              input: "When should I use Définicils?",
              expected:
                "Définicils Mascara is ideal for everyday wear when you want natural-looking, defined lashes without dramatic volume.",
              received:
                "Définicils Mascara is ideal for everyday wear when you want natural-looking, defined lashes without dramatic volume.",
              success: true,
              id: "e89471e3-ad9f-4999-968b-2274387570da",
            },
          ],
        },
      ],
    },
    {
      id: "e999902c-508b-4706-a5e7-086f0593d898",
      name: "Eye Makeup",
      testCoverage: 87,

      children: [
        {
          id: "02b49e6d-08e5-4dcc-bf47-f6991b5c8256",
          name: "Hypnôse Eyeshadow Palette",

          testCoverage: 60,

          tests: [
            {
              input: "What does Hypnôse Eyeshadow Palette offer?",
              expected:
                "Hypnôse Eyeshadow Palette provides a curated selection of shades for creating hypnotic eye looks with blendable, long-wearing formulas.",
              received:
                "Hypnôse Eyeshadow Palette is just a basic eyeshadow palette with cheap, chalky formulas that don't blend well.",
              success: false,
              id: "282e8785-077d-4a07-bf1e-39af5ddca344",
            },
            {
              input: "How do I use Hypnôse Eyeshadow Palette?",
              expected:
                "Use the lighter shades as base colors, medium shades for definition, and darker shades for depth and drama. Blend for seamless transitions.",
              received:
                "Just apply any color randomly to your eyelids, no need for technique or blending. The colors will work themselves out.",
              success: false,
              id: "8b12d290-2f50-4d9c-8999-b899a57ecfb7",
            },
          ],
        },
        {
          id: "49d5ff4f-3bb2-49a3-ac8d-a60ca59f48c3",
          name: "Le Crayon Khôl",
          testCoverage: 50,

          tests: [
            {
              input: "What is Le Crayon Khôl used for?",
              expected:
                "Le Crayon Khôl is a soft, creamy eyeliner pencil perfect for lining the waterline, tightlining, and creating smudged, smoky eye looks.",
              received:
                "Le Crayon Khôl is a hard, dry pencil that's difficult to apply and will scratch your eyes. Avoid it completely.",
              success: false,
              id: "e8afbcfc-1b15-46a9-9d86-17d390808162",
            },
            {
              input: "How do I apply Le Crayon Khôl?",
              expected:
                "Apply Le Crayon Khôl to the waterline or lash line, then smudge with a brush or finger for a soft, smoky effect.",
              received:
                "Apply Le Crayon Khôl with heavy pressure directly to your eyeball for maximum intensity. No need to be gentle.",
              success: false,
              id: "774b4581-77f9-4de9-bedf-c3352aca1976",
            },
          ],
        },
        {
          id: "c2394003-670c-481f-9804-9501b5297fd6",
          name: "Artliner Eyeliner",
          testCoverage: 45,

          tests: [
            {
              input: "What makes Artliner Eyeliner special?",
              expected:
                "Artliner Eyeliner features a precise felt-tip applicator for creating perfect wings and sharp lines with long-lasting, smudge-proof formula.",
              received:
                "Artliner Eyeliner is just a basic eyeliner with a cheap brush that smudges easily and doesn't last more than an hour.",
              success: false,
              id: "106def93-9cb7-4d71-90f8-e9d60f5d5a16",
            },
            {
              input: "How do I create a wing with Artliner?",
              expected:
                "Start from the outer corner of your eye, draw a line extending outward, then connect it back to your lash line and fill in for a perfect wing.",
              received:
                "Just draw a straight line from your eye to your temple, no need for technique or precision. Any line will work.",
              success: false,
              id: "1784c4be-beae-4755-8e75-b962f5feed05",
            },
          ],
        },
        {
          id: "8a705323-08b2-4703-8dc0-a62b264feb20",
          name: "Sourcils Styler",
          testCoverage: 35,

          tests: [
            {
              input: "What does Sourcils Styler do?",
              expected:
                "Sourcils Styler is a brow gel that shapes, defines, and holds eyebrows in place while adding natural-looking color and volume.",
              received:
                "Sourcils Styler is just hairspray in a tube that will make your eyebrows stiff and unnatural looking.",
              success: false,
              id: "b06eaed6-998e-4f87-8b7d-b9592d9512ab",
            },
            {
              input: "How do I use Sourcils Styler?",
              expected:
                "Brush Sourcils Styler through your eyebrows in the direction of hair growth to shape, define, and hold them in place all day.",
              received:
                "Apply Sourcils Styler against the direction of hair growth and use as much as possible to get maximum hold.",
              success: false,
              id: "12be814a-b9f8-4b13-996e-7d500b3310dd",
            },
          ],
        },
      ],
    },
  ],
};
